import { handleError, MyAxios } from '@app/services/SettingAxios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { PaginationType, ModalProductType } from '../types/catalogSchema';
import { getParametersProcessing } from '@entities/Catalog';

export const fetchGetModels = createAsyncThunk<{ data: ModalProductType[]; pagination: PaginationType }, { params: string; regionId: number }>(
  'catalog/fetchGetModels',
  async ({ params, regionId }) => {
    return await MyAxios.get('/api/catalog/models/filter' + getParametersProcessing(params, regionId))
      .then(response => response.data)
      .catch(handleError);
  },
);
